import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

/**
 * 统一的时间格式化函数
 * 处理ISO格式时间字符串（如：2025-06-09T17:39:49Z），去除时区影响
 * @param {string|number|Date} dateTime - 时间值，支持ISO字符串、时间戳、Date对象
 * @param {string} format - 格式化模板，默认为 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} 格式化后的时间字符串
 */
export function formatTime(dateTime, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!dateTime) return '--'
  
  try {
    // 这里已经使用本地时间,分库了,因此不用使用utc了
    // 如果是ISO格式的字符串（包含T和Z），去除时区信息
    if (typeof dateTime === 'string' && dateTime.includes('T')) {
      // 去除Z及后面的所有时区信息
      dateTime = dateTime.replace(/[+-]\d{2}:\d{2}$/, '')
      return dayjs(dateTime).format(format)
    }

    // 其他情况使用本地时间解析
    return dayjs(dateTime).format(format)
  } catch (error) {
    console.error('时间格式化错误:', error, dateTime)
    return '无效时间'
  }
}

/**
 * 格式化为日期（不包含时间）
 * @param {string|number|Date} dateTime - 时间值
 * @returns {string} 格式化后的日期字符串 (YYYY-MM-DD)
 */
export function formatDate(dateTime) {
  return formatTime(dateTime, 'YYYY-MM-DD')
}

/**
 * 格式化为时间（不包含日期）
 * @param {string|number|Date} dateTime - 时间值
 * @returns {string} 格式化后的时间字符串 (HH:mm:ss)
 */
export function formatTimeOnly(dateTime) {
  return formatTime(dateTime, 'HH:mm:ss')
}

/**
 * 格式化为年月
 * @param {string|number|Date} dateTime - 时间值
 * @returns {string} 格式化后的年月字符串 (YYYY-MM)
 */
export function formatYearMonth(dateTime) {
  return formatTime(dateTime, 'YYYY-MM')
}

/**
 * 格式化为年月日时分（不含秒）
 * @param {string|number|Date} dateTime - 时间值
 * @returns {string} 格式化后的时间字符串 (YYYY-MM-DD HH:mm)
 */
export function formatDateTime(dateTime) {
  return formatTime(dateTime, 'YYYY-MM-DD HH:mm')
}

// 兼容旧版本函数
export function formatTimeToStr(times, pattern) {
  if (pattern) {
    return formatTime(times, pattern)
  }
  return formatTime(times)
}

// 兼容transFromTime函数
export function transFromTime(timespan, type = '') {
  if (type === 'only_day') {
    return formatDate(timespan)
  }
  
  // 如果type是格式字符串（包含Y、M、D、H、m、s等），则作为格式使用
  if (type && (type.includes('Y') || type.includes('M') || type.includes('D') || type.includes('H') || type.includes('m') || type.includes('s'))) {
    return formatTime(timespan, type)
  }
  
  return formatTime(timespan)
}

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
// eslint-disable-next-line no-extend-native
Date.prototype.Format = function(fmt) {
  const o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  const reg = /(y+)/
  if (reg.test(fmt)) {
    const t = reg.exec(fmt)[1]
    fmt = fmt.replace(
      t,
      (this.getFullYear() + '').substring(4 - t.length)
    )
  }
  for (let k in o) {
    const regx = new RegExp('(' + k + ')')
    if (regx.test(fmt)) {
      const t = regx.exec(fmt)[1]
      fmt = fmt.replace(
        t,
        t.length === 1 ? o[k] : ('00' + o[k]).substring(('' + o[k]).length)
      )
    }
  }
  return fmt
}
